import type { Registry } from '@luna/utils';
import { createRegistry } from '@luna/utils';

import type { MenuItemStrategy } from './typing';

export const createMenuItemRegistry = <Product>(
    menuItemStrategies: Record<string, MenuItemStrategy<Product>>,
): Registry<MenuItemStrategy<Product>> =>
    createRegistry<MenuItemStrategy<Product>>(menuItemStrategies);
